import styled from 'styled-components'

import { buttonColorCSS } from './utils'
import { BaseButton } from '../BaseButton'

export const PendingButtonStyled = styled(BaseButton)`
  ${(props) => buttonColorCSS(props.theme.colors.button.pending)}
`
